import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { act } from "react";
import secureLocalStorage from "react-secure-storage";
import { decryptMessage } from "../../crypto/cryptoMessage";

export const initialState = {
    messages: [],
    unReadCount : 0,
    chatIsOpen: false,
}
export const fetchNewMessages = createAsyncThunk(
    'messages/fetchMessages',
    async ({ page, platform_id }, { dispatch, rejectWithValue }) => {
      const token = secureLocalStorage.getItem('token')
      try {
        const { data } = await axios.post(`${process.env.REACT_APP_CHAT_SERVICE_HTTP}/init/cabinet/messages?page=${page}&limit=20`,
          {
            platform_id
          },{
            headers:{
                Authorization: `Bearer ${token}`
            }
          });
        if (!data) {
          const errorText = `Ошибка: 'Unknown error'}`;
          return rejectWithValue(errorText);
        }
        const decryptData = await JSON.parse(decryptMessage(data));

        return { data: decryptData, hasNext: decryptData.hasNext };
  
      } catch (err) {
        return rejectWithValue(err.message || 'Network error');
      }
    }
  );
const chatSlice = createSlice({
    name: "chat",
    initialState,
    reducers: {
        setChatIsOpen: (state, action) => {
            state.chatIsOpen = action.payload;
        },
        readMessages: (state, action) => {
            state.unReadCount = 0;
        },
        setUnReadCount: (state, action) => {
            state.unReadCount = action.payload;
        },
        sendMessage: (state, action) => {
            const {msg } = action.payload
        },
        deleteMessage: (state,action) =>{
            const {id, decrement} = action.payload
            console.log(action.payload)
            const index = state.messages.findIndex(m=> m.id === id)
            if(index !== -1){
                state.messages = state.messages.filter(msg=> msg.id !== id)
            }
            if(state.unReadCount){
                state.unReadCount  = state.unReadCount - decrement;
            }
        },
        addMessage: (state, action) => {
          const {msg} = action.payload
          state.messages.push(msg);
          if(!state.chatIsOpen) {
            state.unReadCount += 1;
          }
        },
        editMessage:(state,action) =>{
          const {msg} = action.payload
            const index = state.messages.findIndex(m => m.id === msg.id);
            if (index !== -1) {
                state.messages[index] = { ...state.messages[index], ...msg };
            }
        },
    },
    extraReducers: builder => {
      builder
        .addCase(fetchNewMessages.fulfilled, (state, action) => {
          const messages = action.payload.data.pageDocs;
          messages.forEach(m => {
            const exists = state.messages.some(el => el.id === m.id);
            if (!exists) {
              state.messages.unshift({
                ...m,
              });
            }
          });
        })
        .addCase(fetchNewMessages.rejected, (state, action) => {
          console.error('Ошибка загрузки уведомлений:', action.payload);
        })
    }
});

export const { addMessage, sendMessage, setUnReadCount, setChatIsOpen, readMessages, editMessage, deleteMessage } = chatSlice.actions;
export default chatSlice.reducer;